export * from '@fhs/routing/src/routes/v2/menu-sync/index';
export { default } from '@fhs/routing/src/routes/v2/menu-sync/index';
